import { switchAccountActionsCreator } from 'store/toolkit/switchAccount/switchAccount.reducer'

export const updateSwitchAccount = id => switchAccountActionsCreator.updateSwitchAccount(id)

export { updateSwitchAccount as default }
